import React from "react"
import { Link } from "react-router-dom"
import propTypes from "prop-types"
import { connect } from "react-redux"
import "./styles.scss"

import Header from "../../../../components/Header"
import Footer from "../../../../components/Footer"
import Button from "../../../../components/Button"
import iconComplete from "./images/icon-complete.svg"
import { downloadPlan } from "../../../../services/plans"

const Congratulations = ({ store }) => {
  const onDownloadPlan = e => {
    e.preventDefault()

    downloadPlan(store.user.token, store.plan.id)
  }
  return (
    <div className="main-container main-container--dark">
      <Header theme="light" hideNotifications />

      <div className="content welcome">
        <div className="content_section_header">
          <div className="container">
            <div className="row">
              <div className="col-md-6 offset-md-3">
                <h1 className="content_section_title">Congratulations</h1>
                <div className="content_section_icon">
                  <img src={iconComplete} title="Complete" alt="Complete" />
                </div>
                <h1 className="content_section_title">
                  You have finished your pre-plan
                </h1>
                <div className="content_section_description">
                  Your allocated Local Area Coordinator will now be able to
                  explore this pre-plan with you in more detail. Please make
                  contact with your LAC.
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 offset-md-3">
                <div className="text-center">
                  <Button
                    type="button"
                    onClick={onDownloadPlan}
                    className="btn--secondary-light btn--width-full btn--height-lg btn--font-size-sm"
                  >
                    Download Plan
                  </Button>
                  <Link to="/my-plan" className="link">
                    Back to Dashboard
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

Congratulations.propTypes = {
  store: propTypes.shape({
    user: propTypes.shape({
      token: propTypes.string
    }),
    plan: propTypes.shape({
      id: propTypes.oneOfType([propTypes.string, propTypes.number])
    })
  }).isRequired
}

const mapStateToProps = ({ AuthenticationReducer, PlansReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    plan: PlansReducer
  }
})

export default connect(mapStateToProps)(Congratulations)
